export type CrmAutomationEvent =
  | { type: "lead_stage_entered"; funnelId: string | null; stage: string }
  | { type: "tag_added"; tagId: string };

export function matchCrmTrigger(
  triggerType: string,
  config: Record<string, unknown>,
  event: CrmAutomationEvent,
): boolean {
  if (triggerType === "lead_stage_entered" && event.type === "lead_stage_entered") {
    const stage = String(config.stage || config.stage_slug || "");
    if (!stage || event.stage !== stage) return false;
    const funnelId = String(config.funnel_id || "");
    if (funnelId && event.funnelId && funnelId !== event.funnelId) return false;
    return true;
  }
  if (triggerType === "tag_added" && event.type === "tag_added") {
    const tagId = String(config.tag_id || "");
    return Boolean(tagId) && tagId === event.tagId;
  }
  return false;
}

export function conversationChannelToAutomationChannel(channel: string): string {
  if (channel === "instagram") return "instagram_dm";
  return channel;
}

export const CRM_MESSAGE_CHANNELS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "instagram", label: "Instagram" },
  { value: "messenger", label: "Messenger" },
] as const;

export type CrmMessageChannel = (typeof CRM_MESSAGE_CHANNELS)[number]["value"];

export function providersForCrmMessageChannel(
  channel: string,
): import("@/integrations/supabase/types").Database["public"]["Enums"]["integration_provider"][] {
  if (channel === "whatsapp") return ["whatsapp_evolution", "whatsapp_uazapi", "whatsapp_cloud"];
  if (channel === "messenger") return ["messenger"];
  if (channel === "instagram") return ["instagram"];
  return [];
}
